import { IPayloadCreateDegree } from 'app/api/degree/model'
import R from 'app/assets/R'
import { IRefModal } from 'app/components/common/ModalComponent'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { notificationController } from 'app/controllers/notification-controller'
import { useCreateDegree } from 'app/react-query/hook/degree'
import { useRef } from 'react'
import { useTranslation } from 'react-i18next'

export const useHook = () => {
  const { t } = useTranslation()
  const [form] = BaseForm.useForm<IPayloadCreateDegree>()
  const modalRef = useRef<IRefModal>({})

  const { mutateAsync: mutateAsyncUpdate, isLoading } = useCreateDegree()

  const handleSubmit = async (values: IPayloadCreateDegree) => {
    await mutateAsyncUpdate?.(values)
    modalRef?.current?.hide?.()
    form?.resetFields()
    notificationController.success({
      message: t(R.strings.success),
    })
  }

  return {
    form,
    modalRef,
    handleSubmit,
    isLoading,
  }
}
